import { FunctionComponent } from 'react';
import getConfig from 'next/config';

import { Routes } from 'types/routes';

import { Roles } from 'models/User';

import Button, { ButtonElements, ButtonStyles, ButtonTypes } from 'components/layout/Button';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPagePasswordResetPasswordChanged: FunctionComponent<Props> = ({ translations, state }) => {
    const { publicRuntimeConfig } = getConfig();
    const btnLabel =() =>{
        switch(state?.profile?.role) {
            case Roles.Worker:
                return translations.buttonLabelWorker;
                break;
            case Roles.Company:
                return translations.buttonLabelCompany;
                break;
            default:
                return translations?.buttonLabelWorker;
        }
    };
    const btnHref =() =>{
        switch(state?.profile?.role) {
            case Roles.Worker:
                return   publicRuntimeConfig.WORKER_PANEL_URL + Routes.WorkerHome;
                break;
            case Roles.Company:
                return publicRuntimeConfig.COMPANY_PANEL_URL + Routes.CompanyAccount;
                break;
            default:
                return publicRuntimeConfig.WORKER_PANEL_URL + Routes.WorkerHome;
        }
    };
    return (
        <StyledComponent
            className="public-page-password-reset-password-changed"
        >
            <LayoutContainer size={Sizes.ExtraSmall}>
                <div className="content-container">
                    <header className="header">
                        <img
                            className="icon"
                            src="/images/job/job/check.svg"
                            alt=""
                            aria-hidden="true"
                            loading="lazy"
                        />
                        <h2
                            className="headline"
                            dangerouslySetInnerHTML={{ __html: translations?.headline }}
                        />
                    </header>
                    <Button
                        type={ButtonTypes.Button}
                        style={ButtonStyles.Primary}
                        element={ButtonElements.Anchor}
                        className="submit-button"
                        href={btnHref()}
                    >
                        {btnLabel()}
                    </Button>
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPagePasswordResetPasswordChanged;